isWithinRange